export function isBlendMode(value) {
    return [
        'normal',
        'multiply',
        'screen',
        'overlay',
        'darken',
        'lighten',
        'color-dodge',
        'saturation',
        'color',
        'luminosity',
    ].includes(value);
}
//# sourceMappingURL=blend-mode.js.map